import { render } from "./CreatePR.vue?vue&type=template&id=ece32746"
import script from "./CreatePR.vue?vue&type=script&lang=js"
export * from "./CreatePR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__